/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_calendarexport.js                                                                    */
/**********************************************************************************************************************/
/* Controller GUI */
HafasWebapp.prototype.Controller.CalendarExport = {
  currentConnection: null,
  currentOverlay: null,

  showExportOptions: function (data) {
    var me = this;
    var calendarExportController = this.Controller.CalendarExport;

    // Tracking
    Hafas.ps.pub('/tracking/event/button-calendar', [{typ: 'event', key: 'button-calendar'}]);

    if (Hafas.Modules.History)
      Hafas.Modules.History.addSubView("/GUI/calendarExport/closeOptions", "ExportPopup", {});

    var results = this.Controller.TP.instance.getResults(data.connectionType, data.subclusterGrpId);

    if (data.connectionType == 'PT') {
      calendarExportController.currentConnection = results[data.arrayIdx - 1];
    } else {
      calendarExportController.currentConnection = results[data.arrayIdx - 1].resolvedConnection;
    }

    Hafas.bind(calendarExportController.getCalDetails, me)(function (calSubject, calText) {
      var calFormats = Hafas.bind(calendarExportController.createCalFormats, me)(calSubject, calText);
      Hafas.bind(calendarExportController.renderExportOptions, me)(calFormats, data.trigger);
    });
  },

  getCalDetails: function (callback) {
    var currentConnection = this.Controller.CalendarExport.currentConnection;

    var ctxRecon = currentConnection.ctxRecon || currentConnection.recon.ctx;
    var shareTripReq = Hafas.Core.newType('hafasHCIRequestObject', 'ShareTrip', {
      'req.ctxRecon': ctxRecon,
      'req.mode': 'TEXT_CAL'
    });
    // HCI >= 1.56 (req.modes)
    shareTripReq.add('req.modes', 'TEXT_CAL');
    var shareTrip = Hafas.Core.newType('hafasHCIRequest', {requests: [shareTripReq]});

    Hafas.Core.newType("hafasRequest", {
      hciRequestObj: shareTrip,
      requestType: 'hci',
      callback: Hafas.bind(function (reqResult) {
        var errorStatus = false;
        var calSubject = null;
        var calText = null;
        if (typeof reqResult.resultStatus == 'undefined' || typeof reqResult.resultStatus[0] == 'undefined' || reqResult.resultStatus[0].error || (reqResult.svcResL[0].res.text == undefined && reqResult.svcResL[0].res.texts == undefined)) {
          errorStatus = true;
        } else {
          var result = reqResult.svcResL[0].res;
          // Differentiation how to process the result, with newer versions it comes in a "texts" object
          if(result.texts !== undefined){
            for(var i=0; i < result.texts.length;i++){
              var currentText = result.texts[i];
              // Search for correct result set
              if(currentText.mode == 'TEXT_CAL'){
                calSubject = currentText.subject;
                calText = currentText.text;
              }
            }
          }else {
            calSubject = result.subject;
            calText = result.text;
          }
        }
        callback(calSubject, calText);
      })
    });
  },

  createCalFormats: function (calSubject, calText) {
    var currentConnection = this.Controller.CalendarExport.currentConnection;

    var startLoc = currentConnection.secL[0].dep;
    var destLoc = currentConnection.secL[currentConnection.secL.length - 1].arr;

    var startTime = Hafas.Core.newType('hafasTime', {
      date: currentConnection.date,
      time: startLoc.dTimeS
    }).jsDate;
    var tmpDateSString = startTime.toISOString().replace(/-|:|\./g, '');
    var tmpDateSPart = tmpDateSString.substr(0, (tmpDateSString.length - 4));
    tmpDateSPart = tmpDateSPart + 'Z';

    var destTime = Hafas.Core.newType('hafasTime', {
      date: currentConnection.date,
      time: destLoc.aTimeS
    }).jsDate;
    var tmpDateEString = destTime.toISOString().replace(/-|:|\./g, '');
    var tmpDateEPart = tmpDateEString.substr(0, (tmpDateEString.length - 4));
    tmpDateEPart = tmpDateEPart + 'Z';

    var encodedDescription = encodeURIComponent(calText);
    encodedDescription = encodedDescription.replace(/%40%40%40/g, "%0A");

    var paramObj = {
      title: calSubject,
      location: startLoc.locResolved.name,
      date_start_z: tmpDateSPart,
      date_end_z: tmpDateEPart,
      description: encodedDescription,
      platform: startLoc.dPlatformResolved.platformResolved,
      platformType: startLoc.dPlatformResolved.platformType
    };

    var calendarOptions = [
      {
        icnClass: 'haf_ic_google',
        format: 'google',
        baseUrl: 'https://www.google.com/calendar/render?action=TEMPLATE&',
        label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_google')
      },
      {
        icnClass: 'haf_ic_yahoo',
        format: 'yahoo',
        baseUrl: 'http://calendar.yahoo.com/?view=d&v=60&type=20&',
        label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_yahoo')
      },
      {
        format: 'ics',
        baseUrl: '',
        label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_ics')
      }
    ];

    var calFormats = [];

    for (var c = 0; c < calendarOptions.length; c++) {
      if (typeof Hafas.Config.Export.Calendar[calendarOptions[c].format] != 'undefined' && ((Hafas.Config.Export.Calendar[calendarOptions[c].format] == true) || (typeof Hafas.Config.Export.Calendar[calendarOptions[c].format].use != 'undefined' && Hafas.Config.Export.Calendar[calendarOptions[c].format].use))) {
        calFormats.push(calendarOptions[c]);
      }
    }

    for (var i = 0; i < calFormats.length; i++) {
      var exportUrl = calFormats[i].baseUrl;
      var loc = paramObj.location;
      if (paramObj.platform && paramObj.platformType) {
        var pltfType = "t_S_platform_" + paramObj.platformType;
        loc += " → " + Hafas.Modules.i18n.get('common.platform.' + pltfType) + " " + paramObj.platform;
      }

      if (calFormats[i].format == 'google') {
        exportUrl += 'text=' + encodeURIComponent(paramObj.title)
            + '&location=' + encodeURIComponent(loc)
            + '&details=' + paramObj.description
            + '&dates=' + paramObj.date_start_z + '/' + paramObj.date_end_z;
      } else if (calFormats[i].format == 'yahoo') {
        exportUrl += 'title=' + encodeURIComponent(paramObj.title)
            + '&in_loc=' + encodeURIComponent(loc)
            + '&desc=' + paramObj.description
            + '&st=' + paramObj.date_start_z
            + '&et=' + paramObj.date_end_z;
      } else {
        var tmpDesc = paramObj.description;
        calFormats[i].title = paramObj.title;
        calFormats[i].date_start_z = paramObj.date_start_z;
        calFormats[i].date_end_z = paramObj.date_end_z;
        calFormats[i].description = tmpDesc;
        calFormats[i].location = loc;
      }

      calFormats[i].href = exportUrl;
    }

    return calFormats;
  },

  renderExportOptions: function (calFormats, trigger) {
    var me = this;

    Hafas.Modules.Render.render(
      {
        template: 'TP_AtomCalendarExportExportList',
        model: {formats: calFormats}
      },
      function (html) {
        // generate output-HTML for overlay
        var outputHtml = html.replace(/\n/g, '');

        me.Controller.CalendarExport.currentOverlay = Hafas.Core.newType("HafasOverlay", {
          app: me,
          anchorElement: trigger,
          anchoredOverlay: 'DESKTOP',
          outputHTML: outputHtml,
          title: Hafas.Modules.i18n.get('common.label.t_N_CalendarExport'),
          closeViaCancel: true,
          cssClass: 'hfs_calendarExportOverlay',
          onClose: function () {
            if (Hafas.Modules.History)
              Hafas.Modules.History.removeCurrentStep("ExportPopup");
          }
        });
      }
    );
  },

  closeExportOptions: function () {
    var currentOverlay = this.Controller.CalendarExport.currentOverlay;

    if (currentOverlay != null) {
      currentOverlay.close();
    }
    currentOverlay = null;
  }
};
